import React from "react";
import Skeleton from "react-loading-skeleton";

const CommanTable = ({ columns, data, status, onDelete, onEdit, databstarget, model }) => {
    function stripHtmlTags(html) {
        const tmp = document.createElement("div");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }

    return (
        <div className="table-responsive">
            <table className="table table-hover">
                <thead className="table-primary">
                    <tr>
                        <th scope="col">S.no</th>
                        {onEdit && (<th scope="col">Image</th>)}
                        {columns.map((column, index) => (
                            <th key={index} scope="col">
                                {column.label}
                            </th>
                        ))}
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {status === "loading" && (
                        <tr className="my-2">
                            <td colSpan={columns.length + 3}>
                                <Skeleton count={10} height={40} />
                            </td>
                        </tr>
                    )}
                    {status === "failed" && (
                        <tr>
                            <td colSpan={columns.length + 3}>
                                <p className="text-center fw-bold">{"Data not found"}</p>
                            </td>
                        </tr>
                    )}
                    {status === "succeeded" &&
                        data.map((item, index) => (
                            <tr key={item._id}>
                                <td>
                                    <td>{index + 1}</td>
                                </td>
                                {
                                    (item.Image || item.GelleryImage || item.PressImage || item.thumbnail || item.AboutImage) && (
                                        <td><img src={item.Image || item.GelleryImage || item.PressImage || item.thumbnail || item.AboutImage} width={"70"} height={"70"} className='rounded-circle img-fit' alt="" /> </td>
                                    )
                                }
                                {columns.map((column, colIndex) => (
                                    <td key={colIndex}>
                                        {column.accessor
                                            ? column.accessor === "serialNumber"
                                                ? index + 1
                                                : column.formatter
                                                    ? column.formatter(item[column.accessor])
                                                    : column.accessor === "description" || "content"
                                                        ? stripHtmlTags(item[column.accessor])
                                                        : item[column.accessor]
                                            : ""}
                                    </td>
                                ))}

                                <td>
                                    {onEdit && (<div className="cursor" onClick={() => onEdit(item._id)} data-bs-toggle={model} data-bs-target={databstarget}>
                                        <i className="bi bi-pencil-square text-primary fs-5"></i>
                                    </div>)}

                                    <div className="cursor" onClick={() => onDelete(item._id)}>
                                        <i className="bi bi-trash text-danger fs-5"></i>
                                    </div>

                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>
        </div>
    );
};

export default CommanTable;
